/**
 * Career data for the Career Journey module
 * Presented in reverse chronological order (most recent first)
 */
export const careerData = [
  {
    id: "indigo",
    title: "Lead Pressperson / Technical Education Specialist",
    company: "INDIGO INK DIGITAL PRINTING, INC",
    period: "August 2021 - Present (3+ years)",
    location: "Columbia, Maryland",
    learningPhase: "Advanced Technical Education Development",
    description: "Operating HP Indigo digital press while driving technical innovation and creating comprehensive technical documentation and educational content for print production processes.",
    achievements: [
      {
        title: "Technical Education Development",
        details: [
          "Created and maintained 'Indigorgeous', comprehensive documentation covering print technology and production guidelines",
          "Lead content creator and co-host of IndigoEdge Webinar Series delivering technical education on print embellishment",
          "Featured speaker at PaperSpecs Live, presenting workshop on digital foil innovation",
          "Developed systematic process documentation for specialty printing techniques"
        ]
      },
      {
        title: "Technical Innovation & Systems Development",
        details: [
          "Architected automation suite including pricing intelligence system, client onboarding, and JDF workflow tools using Python, Azure Cloud Services, and SQL",
          "Developed analytics systems for tracking press performance and production metrics",
          "Led R&D initiatives for specialty substrates and finishing techniques",
          "Created technical applications using Excel/VBA including Spine Calculator for binding specifications and production analytics tools"
        ]
      },
      {
        title: "Technical Operations & Consulting",
        details: [
          "Provided technical consultation to teams and clients on premium finishing including digital foil and advanced embellishments",
          "Performed mechanical/electrical maintenance, diagnostics, and calibration for digital press equipment",
          "Managed color control, pre-flight file checking, and system administration for digital front end",
          "Managed substrate inventory and vendor relationships while maintaining production quality"
        ]
      }
    ],
    skills: [
      { 
        name: "Technical Documentation", 
        level: 95, 
        description: "Creating comprehensive reference materials for complex technical systems" 
      },
      { 
        name: "Training Development", 
        level: 90, 
        description: "Designing educational programs with clear objectives and outcomes" 
      },
      { 
        name: "Technical Systems Development", 
        level: 85, 
        description: "Creating automation tools and workflow systems" 
      },
      { 
        name: "Process Analysis", 
        level: 90, 
        description: "Breaking down complex procedures into learnable components" 
      }
    ],
    learningOutcomes: [
      "Advanced information architecture for technical subjects",
      "Educational content creation and delivery methods",
      "Technical system architecture and integration",
      "Leadership in technical innovation initiatives"
    ]
  },
  {
    id: "staples-digital",
    title: "Digital Press Specialist / Production Specialist",
    company: "STAPLES",
    period: "April 2019 - February 2021 (1 year 10 months)",
    location: "Columbia & Baltimore, Maryland",
    learningPhase: "Technical Production & Documentation Specialization",
    description: "Managed digital press operations while developing comprehensive documentation and training materials for complex printing equipment and processes.",
    achievements: [
      {
        title: "Technical Documentation & Training",
        details: [
          "Authored comprehensive operational manuals for complex finishing equipment",
          "Created detailed troubleshooting guides with decision trees and diagnostic steps",
          "Developed visual technical reference materials including diagrams and workflow charts",
          "Conducted cross-training sessions for production team members"
        ]
      },
      {
        title: "Process Optimization & Analytics",
        details: [
          "Spearheaded production optimization initiatives, reducing pre-configured job click count by 58% through advanced imposition techniques",
          "Led color calibration and print quality control for iGen 5 Press operations",
          "Developed comprehensive analytics system for equipment utilization and bindery productivity metrics",
          "Created detailed 3D facility models for workflow and infrastructure planning"
        ]
      },
      {
        title: "Technical Operations Management",
        details: [
          "Managed operations across diverse digital print equipment including Xerox iGen 5, Baltoro Inkjet, Color 1000, Versant 3100, and Nuvera",
          "Operated wide format production including HP T3500, Latex R2000, and Latex 560",
          "Provided training and technical support for finishing equipment including Challenge CMT-130 and Duplo DC-746",
          "Led workflow optimization initiatives improving production efficiency"
        ]
      }
    ],
    skills: [
      { 
        name: "Procedure Documentation", 
        level: 90, 
        description: "Creating clear, step-by-step operational guides" 
      },
      { 
        name: "Technical Training", 
        level: 85, 
        description: "Delivering hands-on equipment training with measurable outcomes" 
      },
      { 
        name: "Process Optimization", 
        level: 85, 
        description: "Analyzing and improving technical workflows for efficiency" 
      },
      { 
        name: "Analytics Development", 
        level: 80, 
        description: "Creating systems to track and analyze operational data" 
      }
    ],
    learningOutcomes: [
      "Technical training development for complex equipment",
      "Production process optimization and documentation",
      "Visual instruction design for procedural learning",
      "Advanced analytics for performance measurement"
    ]
  },
  {
    id: "staples-management",
    title: "Print & Marketing Supervisor / Assistant Manager",
    company: "STAPLES",
    period: "July 2017 - April 2019 (1 year 9 months)",
    location: "Roanoke, Virginia",
    learningPhase: "Operational Leadership & Business Development",
    description: "Led print production department and sales team while developing business relationships and implementing operational improvements.",
    achievements: [
      {
        title: "Business Development & Client Relations",
        details: [
          "Drove 90% department revenue increase within first six months through strategic marketing initiatives",
          "Utilized Salesforce CRM analytics to identify growth opportunities, resulting in 35% increase in repeat business",
          "Cultivated and maintained B2B relationships, generating 25% growth in business-to-business sales",
          "Provided comprehensive business solutions consulting for diverse client base"
        ]
      },
      {
        title: "Team Leadership & Development",
        details: [
          "Led and developed 25-person sales team in top 50 nationally ranked location",
          "Implemented streamlined inventory management system, reducing out-of-stocks by 20% while decreasing shrink by 5%",
          "Leveraged Salesforce CRM to identify and execute win-back strategies, achieving 10% sales increase",
          "Provided targeted coaching and professional development for team members"
        ]
      },
      {
        title: "Production & Project Management",
        details: [
          "Produced high-quality marketing materials across multiple business verticals",
          "Managed complex print production workflow from customer consultation to finished product",
          "Implemented quality control processes ensuring consistent output standards",
          "Coordinated cross-departmental resources to complete high-value projects"
        ]
      }
    ],
    skills: [
      { 
        name: "Team Leadership", 
        level: 85, 
        description: "Leading and developing teams to achieve business objectives" 
      },
      { 
        name: "Business Development", 
        level: 80, 
        description: "Identifying opportunities and implementing growth strategies" 
      },
      { 
        name: "Process Improvement", 
        level: 85, 
        description: "Analyzing and optimizing operational workflows" 
      },
      { 
        name: "Client Relationship Management", 
        level: 90, 
        description: "Building and maintaining strategic business relationships" 
      }
    ],
    learningOutcomes: [
      "Business analytics and performance measurement",
      "Strategic team development and leadership",
      "Operational system optimization",
      "Business relationship cultivation and management"
    ]
  },
  {
    id: "education-roles",
    title: "Substitute Teacher / Education Specialist",
    company: "ESS | SOURCE4TEACHERS",
    period: "December 2016 - July 2017 (8 months)",
    location: "Roanoke, Virginia Area",
    learningPhase: "Educational Content & Curriculum Development",
    description: "Designed and implemented educational curriculum while creating supportive learning environments for K-12 students across multiple subject areas.",
    achievements: [
      {
        title: "Curriculum Development",
        details: [
          "Designed and implemented curriculum for K-12 across multiple subject areas",
          "Created engaging educational materials adapted for different learning styles",
          "Developed supplemental learning resources to reinforce key concepts",
          "Aligned lesson plans with established educational standards and objectives"
        ]
      },
      {
        title: "Educational Environment Management",
        details: [
          "Created supportive learning environments while maintaining classroom management standards",
          "Handled confidential student documentation in compliance with HIPAA guidelines",
          "Coordinated with permanent staff to ensure educational continuity",
          "Adapted teaching approaches based on classroom needs and individual learning requirements"
        ]
      }
    ],
    skills: [
      { 
        name: "Curriculum Development", 
        level: 80, 
        description: "Creating structured educational content for diverse audiences" 
      },
      { 
        name: "Instructional Delivery", 
        level: 85, 
        description: "Presenting information in accessible, engaging formats" 
      },
      { 
        name: "Needs Assessment", 
        level: 80, 
        description: "Identifying learning requirements and adapting materials accordingly" 
      },
      { 
        name: "Documentation Management", 
        level: 85, 
        description: "Maintaining accurate records while ensuring confidentiality" 
      }
    ],
    learningOutcomes: [
      "Educational content development for diverse audiences",
      "Instructional delivery and presentation techniques",
      "Learning needs assessment and adaptation strategies",
      "Documentation management and continuity planning"
    ]
  },
  {
    id: "field-organizer",
    title: "Field Organizer",
    company: "NEW VIRGINIA MAJORITY",
    period: "October 2016 - November 2016 (2 months)",
    location: "Virginia",
    learningPhase: "Community Engagement & Information Campaigns",
    description: "Spearheaded voter registration and rights restoration initiatives across multiple regions, creating educational materials and communication strategies.",
    achievements: [
      {
        title: "Public Information Campaign Development",
        details: [
          "Spearheaded voter registration and rights restoration initiatives across Roanoke, Christiansburg, and Radford regions",
          "Created educational materials explaining complex civic processes for diverse audiences",
          "Developed targeted messaging to communicate important information effectively",
          "Designed outreach strategies to reach underrepresented communities"
        ]
      },
      {
        title: "Community Engagement & Coordination",
        details: [
          "Coordinated with local homeless shelters, festivals, and educational institutions to implement voter registration programs",
          "Executed successful Get Out The Vote campaign through targeted neighborhood canvassing",
          "Managed personal metrics tracking and reporting systems",
          "Built community relationships to facilitate information sharing and engagement"
        ]
      }
    ],
    skills: [
      { 
        name: "Information Campaign Development", 
        level: 75, 
        description: "Creating targeted information campaigns for specific audiences" 
      },
      { 
        name: "Community Engagement", 
        level: 80, 
        description: "Building relationships to facilitate information sharing" 
      },
      { 
        name: "Public Communication", 
        level: 85, 
        description: "Translating complex information for diverse audiences" 
      },
      { 
        name: "Data Collection & Reporting", 
        level: 75, 
        description: "Tracking metrics and creating meaningful reports" 
      }
    ],
    learningOutcomes: [
      "Public information campaign development and implementation",
      "Community engagement and relationship building strategies",
      "Clear communication of complex processes to diverse audiences",
      "Metrics tracking and performance reporting"
    ]
  },
  {
    id: "richmond",
    title: "Archaeological Sketch Assistant / Documentation Specialist",
    company: "UNIVERSITY OF RICHMOND",
    period: "December 2015 - August 2016 (9 months)",
    location: "University of Richmond, Virginia",
    learningPhase: "Technical Documentation & Visual Communication",
    description: "Created comprehensive technical documentation for archaeological illustration techniques, developing educational materials for future students.",
    achievements: [
      {
        title: "Technical Documentation Development",
        details: [
          "Utilized Adobe Illustrator CC for precise archaeological documentation at Hacımusalar Höyük site",
          "Created comprehensive technical documentation for future student reference",
          "Developed detailed process illustrations and methodology explanations",
          "Established standardized documentation practices for consistent knowledge transfer"
        ]
      },
      {
        title: "Digital Asset Management & Creation",
        details: [
          "Developed custom digital asset library including specialized palettes, shapes, and brushes",
          "Created reusable visual elements to ensure consistency across documentation",
          "Organized digital resources for efficient access and utilization",
          "Implemented metadata and categorization systems for resource management"
        ]
      }
    ],
    skills: [
      { 
        name: "Technical Writing", 
        level: 85, 
        description: "Creating clear, audience-appropriate technical documentation" 
      },
      { 
        name: "Visual Communication", 
        level: 80, 
        description: "Developing visual aids that support procedural learning" 
      },
      { 
        name: "Digital Asset Management", 
        level: 85, 
        description: "Creating and organizing digital resources for efficient use" 
      },
      { 
        name: "Process Documentation", 
        level: 80, 
        description: "Documenting technical processes with clarity and precision" 
      }
    ],
    learningOutcomes: [
      "Technical documentation development for specialized processes",
      "Visual communication techniques for complex information",
      "Digital asset creation and management",
      "Process standardization and knowledge transfer"
    ]
  },
  {
    id: "brookstone",
    title: "Assistant Manager / Operations Specialist",
    company: "BROOKSTONE",
    period: "December 2012 - July 2015 (2 years 8 months)",
    location: "Jacksonville, Florida",
    learningPhase: "Operational Systems Development & Team Leadership",
    description: "Led store operations and team development while creating technical systems to improve efficiency and performance tracking.",
    achievements: [
      {
        title: "Technical Systems Development",
        details: [
          "Created integrated workflow management system using Excel and VBA scripting for scheduling and operations tracking",
          "Generated accurate 3D store models for visual merchandising and ADA compliance",
          "Optimized operational processes, reducing labor hours by 240 annually",
          "Developed and implemented new company-wide training and sales program"
        ]
      },
      {
        title: "Team Leadership & Development",
        details: [
          "Received Regional Core Values Excellence Award for employee development initiatives",
          "Rebuilt staff roster through strategic hiring and training of associates and part-time management",
          "Conducted quarterly performance reviews and compensation negotiations",
          "Provided comprehensive product training and sales coaching to new team members"
        ]
      },
      {
        title: "Operational Management",
        details: [
          "Managed monthly workflow budgets while maintaining profitability metrics and inventory controls",
          "Created performance incentive systems for high-volume sales periods",
          "Assumed full store management responsibilities while maintaining assistant manager duties during transition periods",
          "Demonstrated excellence in time management and operational efficiency"
        ]
      }
    ],
    skills: [
      { 
        name: "Systems Development", 
        level: 80, 
        description: "Creating technical systems to improve operational efficiency" 
      },
      { 
        name: "Team Leadership", 
        level: 75, 
        description: "Developing and managing high-performing teams" 
      },
      { 
        name: "Process Optimization", 
        level: 80, 
        description: "Analyzing and improving workflows for greater efficiency" 
      },
      { 
        name: "Training Program Development", 
        level: 75, 
        description: "Creating structured learning programs for team development" 
      }
    ],
    learningOutcomes: [
      "Technical systems development for operational improvement",
      "Team building and development strategies",
      "Process analysis and optimization techniques",
      "Performance measurement and incentive program creation"
    ]
  },
  {
    id: "early-career",
    title: "Staff Photojournalist / Sales Associate",
    company: "UNIVERSITY OF RICHMOND / BROOKSTONE",
    period: "May 2007 - November 2012 (5 years 6 months)",
    location: "Richmond, VA / Jacksonville, FL",
    learningPhase: "Foundational Skills Development",
    description: "Developed fundamental skills in visual communication, technical product knowledge, and client relations across complementary roles.",
    achievements: [
      {
        title: "Visual Communication",
        details: [
          "Produced high-quality photojournalistic content for university newspaper",
          "Covered political, community, and entertainment events requiring diverse visual approaches",
          "Utilized Adobe Creative Suite for image editing and optimization",
          "Collaborated with editorial team to align visual content with story requirements"
        ]
      },
      {
        title: "Technical Knowledge & Communication",
        details: [
          "Maintained extensive product knowledge base for in-store and online offerings",
          "Consistently exceeded sales targets and KPIs through effective technical communication",
          "Provided new associate training on active assortment features and benefits",
          "Translated complex product features into clear customer benefits"
        ]
      },
      {
        title: "Time Management & Planning",
        details: [
          "Managed extensive travel schedule while maintaining academic commitments",
          "Demonstrated consistent adherence to company performance standards",
          "Developed systems for balancing competing priorities and deadlines",
          "Established foundational work habits and professional practices"
        ]
      }
    ],
    skills: [
      { 
        name: "Visual Communication", 
        level: 75, 
        description: "Creating visual content to communicate information effectively" 
      },
      { 
        name: "Technical Knowledge Translation", 
        level: 70, 
        description: "Explaining complex technical features in accessible terms" 
      },
      { 
        name: "Client Relationship Building", 
        level: 75, 
        description: "Developing rapport and trust through effective communication" 
      },
      { 
        name: "Time Management", 
        level: 70, 
        description: "Balancing competing priorities and meeting deadlines" 
      }
    ],
    learningOutcomes: [
      "Visual communication principles and practices",
      "Technical information translation for non-technical audiences",
      "Client needs assessment and relationship development",
      "Professional work habits and performance standards"
    ]
  }
];
